var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "room-setting-content-component" },
    [
      _c(
        "perfect-scrollbar",
        { ref: "scrollbar", staticClass: "h-full" },
        [
          _c(_vm.settingComponent, {
            ref: "component",
            tag: "component",
            on: { onUpdateScroll: _vm.onUpdateScroll },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }